import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getTierDeviationsStreamId } from '../helpers';
import { fetchMoreTierDeviations } from '../actions';
import { getCurrentTierId, getCurrentMediaSource } from '../selectors';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
const mapStateToProps = (state)=>{
    const mediaSourceType = getCurrentMediaSource(state);
    const currentTierId = getCurrentTierId(state);
    const streamId = getTierDeviationsStreamId(mediaSourceType, currentTierId);
    return {
        deviations: getDeviationsByIds(state, selectors.getItems(state, streamId)),
        hasMore: selectors.hasMore(state, streamId),
        isInitialized: selectors.isInitialized(state, streamId),
        isFetching: selectors.isFetching(state, streamId)
    };
};
export const useCurrentTierDeviations = ()=>_object_spread({}, useMMSelector(mapStateToProps), useMMDispatchActions({
        fetchMoreTierDeviations
    }));
export default connectMediaStore(mapStateToProps, {
    fetchMoreTierDeviations
});

//# sourceMappingURL=withCurrentTierDeviations.js.map